import {BaseService} from "@/service/BaseService.ts";
import {ReadTeamByWorkspaceIdRequest} from "@/model/request/team/ReadTeamByWorkspaceIdRequest.ts";

export class TeamService {
    static read = (others: any) => {
        return BaseService.apiClient(others).get("/team/read")
    }
    static readTeamByWorkspaceId = (others: any, data: ReadTeamByWorkspaceIdRequest) => {
        return BaseService.apiClient(others).get(`/team/read-by-team-workspace-id/${data.workspaceId}`)
    }
}